import { useTranslation } from 'react-i18next';
import './Input.css'
import './OTPInput.css'
import { Dispatch, forwardRef, SetStateAction, useImperativeHandle, useRef, useState } from 'react';
import { InputInfoMsg } from 'components/common/input/Input';
import {ReactComponent as IcError} from '../../../assets/svgs/icon/ic_error.svg';
import {ReactComponent as IcPassed} from '../../../assets/svgs/icon/ic_passed.svg';
import { palette } from 'common/commonStyle';

interface OTPInputProps {
    inputVal: string,
    setInputVal: Dispatch<SetStateAction<string>>
    time?: number
    resendTime?: number
    onStart: () => void
    infoMsg?: InputInfoMsg
    onChange: (e: React.ChangeEvent<HTMLInputElement>) => void
}

export interface OTPInputRef {
    startCountDown: () => void;
}

export const OTPInput = forwardRef<OTPInputRef, OTPInputProps>(({
    inputVal,
    setInputVal,
    time,
    resendTime,
    onStart,
    infoMsg,
    onChange
}, ref) => {
    const {t} = useTranslation();
    const formatTime = (time: number) => {
        const min = (Math.floor(time / 60)).toString().padStart(2, '0');
        const sec = (time % 60).toString().padStart(2, '0');
        return `${min}:${sec}`
    }
    const timerTime = useRef(time ?? 180);
    const timerId = useRef<NodeJS.Timer | undefined>(undefined);
    const [leftTime, setLeftTime] = useState(formatTime(timerTime.current));
    const [btnDisabled, setBtnDisabled] = useState(true);

    const onStartCountDown = () => {
        onStart();
        if(timerTime.current <= 0) {
            timerTime.current = time ?? 180;
            setLeftTime(formatTime(timerTime.current));
            setBtnDisabled(true);
        }
        timerId.current = setInterval(() => {
            timerTime.current -= 1;
            if(timerTime.current <= 0) {
                clearInterval(timerId.current);
            } else if (timerTime.current < (resendTime ?? 60)) {
                setBtnDisabled(false);
            }
            setLeftTime(formatTime(timerTime.current));
        }, 1000);
    }

    useImperativeHandle(ref, () => ({
        startCountDown(){
            onStartCountDown();
        }
    }))


    return (
        <div style={{padding: "10px 0"}}>
            <div className="common-input-title-container">
                <span className="common-input-title">{t("signUp.otp")}</span>
            </div>
            <div className="otp-input-box">
                <input
                    value={inputVal}
                    onChange={(e) => {
                        setInputVal(e.target.value.replace(/[^0-9]/g, ''))
                        onChange(e)
                    }}
                    className="otp-input"
                    type="text"
                    maxLength={6}
                />
                <button
                    disabled={btnDisabled}
                    className="otp-input-resend"
                    onClick={onStartCountDown}
                >
                    {t("signUp.otpResend")}
                </button>
            </div>
            <div className="otp-input-msg-wrapper">
                <span style={{display: "flex", alignItems: "center", gap: "2px"}}>
                    {infoMsg &&
                        <>
                            {infoMsg.type === "error" &&
                                <IcError
                                    height="12px"
                                    width="12px"
                                    color={palette.warning}
                                />
                            }
                            {infoMsg.type === "passed" &&
                                <IcPassed
                                    height="12px"
                                    width="12px"
                                    color={palette.primary}
                                />
                            }
                            <span className={`common-input-msg ${infoMsg.type}`}>{infoMsg?.msg}</span>
                        </>
                    }

                </span>

                <span className="otp-time-left">{leftTime}</span>
            </div>
        </div>
    )
});
